import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const issueNavigatorGlobalRoute: InvariantJiraRoute = {
	name: 'global-issue-navigator',
	path: '/issues',
};
